import React from "react";
import { VictoryAnimation, VictoryPie, VictoryLabel } from "victory";

class GaugeChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      data: this.getData(0)
    };
  }

  componentDidUpdate = prevProps => {
    if (prevProps.value !== this.props.value) {
      setTimeout(() => {
        this.setState({
          value: +this.props.value,
          label: this.props.label,
          data: this.getData(
            Math.floor((+this.props.value / +this.props.goal) * 100)
          )
        });
      }, this.props.delay)
    }
  };

  getData = percent => {
    if (percent > 100) percent = 100;
    return [
      { x: 1, y: percent, color: "var(--color-primary-500)" },
      { x: 2, y: 100 - percent, color: "transparent" }
    ];
  };

  render() {
    return (
      <div>
        <svg viewBox="0 0 400 400" width="100%" height="100%">
          <VictoryPie
            standalone={false}
            animate={{ onEnter: { duration: 500 } }}
            width={400}
            height={400}
            padding={0}
            data={this.state.data}
            startAngle={-150}
            endAngle={150}
            innerRadius={180}
            cornerRadius={25}
            labels={() => null}
            style={{
              data: {
                fill: d => {
                  return d.color;
                }
              },
            }}
          />
          <VictoryAnimation duration={500} data={this.state}>
            {newProps => {
              let text = this.props.format(this.props.value);
              let payload = [this.props.label, text];

              if (this.props.label !== "% Budget Reached") {
                payload.push('Goal: ' + this.props.format(this.props.goal));
              }
              
              return (
                <VictoryLabel
                  textAnchor="middle"
                  verticalAnchor="middle"
                  lineHeight={1.6}
                  x={200}
                  y={200}
                  text={payload}
                  style={[{ fontSize: 32 }, { fontSize: 48, fill: 'var(--color-secondary-500)' }, { fontSize: 24, fill: "gray" }]}
                  desc={newProps.label}
                />
              );
            }}
          </VictoryAnimation>
        </svg>
      </div>
    );
  }
}

export default GaugeChart;
